export class ObjectSelect {
  relatieid: number;
  cpid: number;
  faseid: number;
  objectNr: number;
  objectSerieNr: number;
  AccountManager: number;
  object: string;
  omschrijving: string;

}


export class ID {
  id : number
}
